import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createSlots as _createSlots, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f150d1a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-header" }
const _hoisted_2 = { style: {"font-size":"22px"} }
const _hoisted_3 = { class: "customer-statistics-page" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-tip" }, "各位小伙伴，请仔细阅读本次客户联系提醒，及时联系客户", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"text-align":"right","margin-bottom":"10px"} }, null, -1))
const _hoisted_6 = {
  key: 0,
  class: "search-form"
}
const _hoisted_7 = { class: "label-with-tip" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question label-tip-icon" }, null, -1))
const _hoisted_9 = {
  key: 1,
  class: "tip-info"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 规则说明："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 1、下组时间用开通运营辅助平台账号的时间"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 2、以当月总业绩排名为准"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3.呼出的电话，没打通的无法录入系统：人工检查业务员呼出情况"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 4.视频电话无法确认识别出来：视频电话也算一通电话"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 5、电话数据统计：接通时长低于1分钟，只计时长不计次数"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 6、周末2天的所有数据算入周五的数据"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 7、判断一周内是否有工作日，如无，不考核"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" （1）前一日电话数据："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 下组3个月内：每月前三周：通次10+50分钟，第四周：通次10+60分钟；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 下组3个月以上：每月前三周：通次10+80分钟，第四周：通次10+100分钟；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 前一日开单1万及以上的每天电话量要求："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 前一日开单1万及以上入职3个月以内的，前三周当天开单的当天至少完成10通+35分钟，第四周当天开单的当天至少完成10通+40分钟；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 前一日开单1万及以上入职3个月以上的，前三周当天开单的当天至少完成10通+50分钟，第四周当天开单的当天至少完成10通+60分钟。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 关于上一个月完成业绩，次月的每天电话数据要求：（针对业绩排名前十的业务员，并列的随机取）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 业绩前十上月完成业绩入职3个月以内的，当月业绩达到6万的前10名，次月前三周电话数据需完成10通+35分钟，第四周电话数据需完成10通+40分钟；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 业绩前十上月完成业绩入职3个月以上的，当月业绩达到10万的前10名，次月前三周电话数据需完成10通+50分钟，第四周电话数据需完成10通+60分钟。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" （15号前入职的从当月起算入职，15号入职以后的从次月起算入职）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" （2）前一日直播数据："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 下组1个月以内业务员，至少5个；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 下组1-2个月业务员至少7个；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 下组2-3个月业务员至少15个；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 下组3个月以上业务员至少22个；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 数据统计标准：前一日直播数据+前一日和当日上午复播数据；"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 以运营辅助平台“客户数量”数据为准 ")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "question-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" })
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "update-tip" }, "当前页面数据周一至周五中午 13 点更新", -1))
const _hoisted_13 = {
  key: 2,
  class: "tip-info"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" 应出业绩计算规则："),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3个月以内资源，应出业绩 10万/1000个"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 3-6个月以内资源，应出业绩 3万/1000个"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 6个月以上资源，应出业绩 1万/1000个 ")
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "question-icon-wrapper" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question" })
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "update-tip" }, "当前数据是每月1号统计的上月资源和业绩", -1))
const _hoisted_17 = {
  key: 3,
  class: "table-container contLoading"
}
const _hoisted_18 = {
  key: 0,
  class: "tree-control"
}
const _hoisted_19 = { class: "label-with-tip" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-question label-tip-icon" }, null, -1))
const _hoisted_21 = { style: {"line-height":"1.6"} }
const _hoisted_22 = {
  key: 0,
  style: {"color":"#67c23a"}
}
const _hoisted_23 = {
  key: 1,
  style: {"color":"#67c23a"}
}
const _hoisted_24 = { style: {"color":"#909399"} }
const _hoisted_25 = { style: {"color":"#909399"} }
const _hoisted_26 = { style: {"color":"#909399"} }
const _hoisted_27 = { class: "multiline-tooltip" }
const _hoisted_28 = { class: "multiline-cell" }
const _hoisted_29 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"40px","height":"40px","background":"#f5f7fa","border-radius":"50%"} }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"40px","height":"40px","background":"#f5f7fa","border-radius":"50%"} }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"40px","height":"40px","background":"#f5f7fa","border-radius":"50%"} }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { style: {"display":"flex","align-items":"center","justify-content":"center","width":"40px","height":"40px","background":"#f5f7fa","border-radius":"50%"} }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { key: 2 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { key: 2 }
const _hoisted_48 = { key: 3 }
const _hoisted_49 = { class: "footer" }
const _hoisted_50 = {
  key: 4,
  class: "call-stat-container contLoading"
}
const _hoisted_51 = {
  class: "stat-card",
  style: { '--theme-color': '#2563eb',marginRight: '50px'}
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "本月已通话次数", -1))
const _hoisted_53 = { class: "card-value" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "次", -1))
const _hoisted_55 = {
  class: "stat-card",
  style: { '--theme-color': '#16a34a' }
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "本月已通话总时长", -1))
const _hoisted_57 = { class: "card-value" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "min", -1))

import { ref, watch,computed,shallowRef } from 'vue'
import {  ElButton, ElMessage, ElMessageBox,ElRadioGroup,ElRadioButton } from "element-plus";
import { CircleCloseFilled, Picture } from '@element-plus/icons-vue'

import { useStore } from '@/store'
import { getListData, getPageListData, downloadData } from '@/service/main/system'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import { ElLoading,ElTooltip } from 'element-plus'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
interface TabConfig {
  key: string;
  label: string;
  api: string;
  exportApi?: string;
  exportBtn?: boolean;
  exportBtnText?: string;
  formItems: Array<{
    label: string;
    prop: string;
    type: 'input' | 'select' | 'date' | 'dateRange';
    options?: Array<{ label: string; value: string | number }>;
    tooltip?: string;
  }>;
  tableColumns: Array<{
    label: string;
    prop: string;
    width?: number;
    showOverflowTooltip?: boolean;
    tooltip?: string;
  }>;
}

// 2. 定义 Tab 列表及对应配置（核心：每个 Tab 对应不同的表单和表格列）

export default /*#__PURE__*/_defineComponent({
  __name: 'tablist',
  emits: ['close'],
  setup(__props, { expose: __expose, emit: __emit }) {

dayjs.locale('zh-cn')

const store = useStore()
const isEmp = computed(() => {
  const roles =store.state.login.userInfo.roles
  if(roles && roles.length > 0){
    return roles.find((role: any) => role.roleName === 'ROLE_EMP') ? true : false
  }else{
    return false
  }
});
// 1. 定义类型
// Tab 配置类型
const tabList = shallowRef<TabConfig[]>([
  {
    key: 'yesterdayWatch',
    label: '前一日观看直播客户',
    api: '/liveCustomerFollowup/getPageWithAuthControl',
    exportApi: '/liveCustomerFollowup/exportWithAuthControl',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'consumerNickName', type: 'input' },
      { label: '客户unionId', prop: 'consumerWxUnionId', type: 'input' },
      {
        label: '是否已成交',
        prop: 'isDealt',
        type: 'select',
        options: [
          { label: '未成交', value: 0 },
          { label: '已成交', value: 1 },
          { label: '未知', value: 3 }
        ]
      },
    ],
    tableColumns: [
      { label: '头像', prop: 'consumerHeadImgUrl', width: 80 },
      { label: '客户昵称', prop: 'consumerNickName', width: 80 },
      { label: '直播间名称', prop: 'channelName', width: 100 },
      { label: '客户unionId', prop: 'consumerWxUnionId', width: 100 },
      { label: '所属组别', prop: 'deptName', width: 80 },
      { label: '所属员工', prop: 'empName', width: 80 },
      { label: '访问时间', prop: 'accessTime', width: 100 },
      { label: '是否已成交', prop: 'isDealt', width: 100 },
      { label: '访问时长', prop: 'duration', width: 100 },
    ],
  },
  {
    key: '30daysOver10',
    label: '30天内累计观看大于10天的客户',
    api: '/watchLiveNotDeal/getPageWithAuthControl',
    exportApi: '/watchLiveNotDeal/exportWithAuthControl',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custNickName', type: 'input' },
      { label: '客户unionId', prop: 'unionid', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      {
        label: '是否已成交',
        prop: 'isDealt',
        type: 'select',
        options: [
          { label: '未成交', value: 0 },
          { label: '已成交', value: 1 }
        ]
      },
    ],
    tableColumns: [
      { label: '主体名称', prop: 'corName', width: 100 },
      { label: '业务员姓名', prop: 'usedBy', width: 100 },
      { label: '业务员工作账号', prop: 'empUserId', width: 100 },
      { label: '头像', prop: 'consumerHeadImgUrl', width: 80 },
      { label: '客户昵称', prop: 'custNickName', width: 100 },
      { label: '客户unionId', prop: 'unionid', width: 120 },
      { label: '是否已成交', prop: 'isDealt', width: 100 },
      { label: '平均每天观看直播时长(秒)', prop: 'avgDailyDuration', width: 160 },
    ],
  },
  // {
  //   key: 'overWeekNoWatch',
  //   label: '超过一周未看直播的客户',
  //   api: '/liveCustomerFollowup/getPageWithAuthControl',
  //   formItems:[],
  //   tableColumns:[]
  // },
  {
    key: 'yesterdayNoReply',
    label: '前一日未回复客户',
    api: '/main/recordNotReplyCust/getPageWithAuthControl',
    exportApi: '/main/recordNotReplyCust/exportWithAuthControl',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户姓名', prop: 'custName', type: 'input' },
      { label: '客户unionId', prop: 'custUnionid', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '业务员工作账号', prop: 'empUserId', type: 'input' },
      { label: '组别', prop: 'groupName', type: 'input' },
    ],
    tableColumns: [
      { label: '主体名称', prop: 'corpName', width: 80 },
      { label: '业务员姓名', prop: 'empName', width: 100 },
      { label: '组别', prop: 'groupName', width: 100 },
      { label: '业务员工作账号', prop: 'empUserId', width: 100 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户姓名', prop: 'custName', width: 100 },
      { label: '客户微信ID', prop: 'custUserId', width: 100 },
      { label: '客户消息时间', prop: 'msgTime', width: 100 },
      { label: '客户消息内容', prop: 'msgContent', width: 170,showOverflowTooltip:true},
      { label: '消息类型', prop: 'msgType', width: 100 },
      { label: '客户unionId', prop: 'custUnionid', width: 120 },
      { label: '业务员回复消息时间', prop: 'replyMsgTime', width: 150 },
      { label: '业务员回复消息内容', prop: 'replyMsgContent', width: 200, showOverflowTooltip: true },
      { label: '业务员回复消息类型', prop: 'replyMsgType', width: 120 },
    ],
  },
  {
    key: 'yesterdaySeeLive',
    label: '前一日观看录播超过3分钟客户',
    api: '/main/fuboAccess/queryConsumerWatchReport',
    exportApi: '/main/fuboAccess/exportConsumerWatchReport',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'consumerNickName', type: 'input' },
      { label: '所属组别', prop: 'deptName', type: 'input',  },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
    ],
    tableColumns: [
      { label: '业务员姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'deptName', width: 100 },
      { label: '头像', prop: 'consumerHeadImgUrl', width: 80 },
      { label: '客户昵称', prop: 'consumerNickName', width: 100 },
      {label: '视频标题', prop: 'title',  width: 170,showOverflowTooltip:true},
      { label: '观看时长(秒)', prop: 'duration', width: 100 },
      { label: '客户unionId', prop: 'consumerWxUnionId', width: 120 },
    ],
  },
  {
    key: 'weekNoGroup',
    label: '近一周不允许拉群客户',
    api: '/main/notAllowCustGroup/getPageWithAuthControl',
    exportApi: '/main/notAllowCustGroup/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户姓名', prop: 'custName', type: 'input' },
      { label: '客户unionId', prop: 'consumerWxUnionId', type: 'input' },
      // { label: '来源渠道', prop: 'channelName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      // { label: '所属组别', prop: 'deptName', type: 'select', options: [] },
    ],
    tableColumns: [
      { label: '群名', prop: 'name', width: 120 },
      { label: '群主工作账号', prop: 'owner', width: 120 },
      { label: '群主姓名', prop: 'usedBy', width: 100 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户姓名', prop: 'custName', width: 100 },
      // { label: '所属三方', prop: 'thirdParty', width: 80 },
      // { label: '来源渠道', prop: 'sourceLabel', width: 80 },
      { label: '拉群时间', prop: 'joinTime', width: 100 },
      { label: '客户unionId', prop: 'unionid', width: 120 },
    ],
  },
  {
    key: 'dayNeedContact',
    label: '新资源承接需联系列表',
    api: '/dailyNewResourcePhone/getPageWithAuthControl',
    exportApi: '/dailyNewResourcePhone/exportNewResourceContact',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custNickName', type: 'input' },
      { label: '客户unionId', prop: 'unionid', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
    ],
    tableColumns: [
      { label: '主体名称', prop: 'corpName', width: 80 },
      { label: '业务员姓名', prop: 'empName', width: 100 },
      // { label: '业务员加入时间', prop: 'empCreatedAt', width: 120 },
      { label: '头像', prop: 'avatar', width: 80 },
      { label: '客户姓名', prop: 'custName', width: 100 },
      { label: '客户第一次加入时间', prop: 'firstCreatedAt', width: 120 },
      // { label: '客户加入当日的业绩', prop: 'firstCreatedAtSalesAmount', width: 80 },
      // { label: '联系类型', prop: 'contactType', width: 100 },
      { label: '联系截止时间', prop: 'contactDeadline', width: 120 },
      // { label: '联系截止日的业绩', prop: 'contactDeadlineSalesAmount', width: 80 },
      { label: '客户unionId', prop: 'unionid', width: 120 },
    ],
  },
  {
    key: 'weekCallLessOrTimeLess',
    label: '本月通话次数和时长统计',
    api: '/main/recordCallDetails/queryMonthlyCallStat',
    exportApi: '/main/recordCallDetails/exportMonthlyCallStat',
    exportBtn: true,
    exportBtnText: '导出',
    formItems:[
      { label: '业务员姓名', prop: 'usedBy', type: 'input' },
    ],
    tableColumns:[
      { label: '业务员姓名', prop: 'usedBy', width: 100 },
      { label: '总通话次数', prop: 'totalCallCount', width: 100 },
      { label: '总通话时长(分)', prop: 'totalCallDurationMin', width: 100 },
    ]
  },
  {
    key: 'duplicateResourceTransaction',
    label: '重复资源成交客户',
    api: '/main/repeatCustSuccList/getPageWithAuthControl',
    exportApi: '/main/repeatCustSuccList/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '主体名称', prop: 'corpName', type: 'input' },
      { label: '客户unionId', prop: 'custUnionid', type: 'input' },
      { label: '成交业务员姓名', prop: 'succEmpName', type: 'input' },
      { label: '其他业务员姓名', prop: 'otherEmpName', type: 'input' },
    ],
    tableColumns: [
      { label: '成交业务员所属企业', prop: 'succCorpName', width: 120 },
      { label: '成交业务员姓名', prop: 'succEmpName', width: 80 },
      { label: '成交业务员所属组别', prop: 'succGroupName', width: 90 },
      { label: '其他业务员所属企业', prop: 'otherCorpName', width: 120 },
      { label: '其他业务员姓名', prop: 'otherEmpName', width: 80 },
      { label: '头像', prop: 'avatar', width: 100 },
      { label: '客户姓名', prop: 'custName', width: 100 },
      { label: '成交时间', prop: 'succTime', width: 120 },
      { label: '客户unionId', prop: 'custUnionid', width: 120 },
    ],
  },
  {
    key: 'liveDepositOrder',
    label: '直播间定金订单客户信息',
    api: '/main/liveQuanzi/queryByConditionWithAuth',
    exportApi: '/main/liveQuanzi/exportDepositOrders',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '商品名', prop: 'productName', type: 'input' },
      { label: '客户昵称', prop: 'nickname', type: 'input' },
      { label: '客户unionId', prop: 'unionid', type: 'input' },
      { label: '所属员工', prop: 'empName', type: 'input' },
      {
        label: '签约状态',
        prop: 'signStatus',
        type: 'select',
        options: [
          { label: '未签约', value: 0 },
          { label: '已签约', value: 1 }
        ]
      },
      {
        label: '支付状态',
        prop: 'status',
        type: 'select',
        options: [
          { label: '等待支付', value: 0 },
          { label: '支付成功', value: 10 },
          { label: '已退款', value: 20 },
          { label: '支付关闭', value: 30 },
          { label: '失败（三方订单不存在）', value: 40 },
          { label: '已过期（超过一周未完成支付）', value: 50 }
        ]
      },
    ],
    tableColumns: [
      { label: '客户昵称', prop: 'nickname', width: 100 },
      { label: '头像', prop: 'avatar', width: 120 },
      { label: '客户unionId', prop: 'unionid', width: 150 },
      { label: '直播间名称', prop: 'channelName', width: 120 },
      { label: '商品名', prop: 'productName', width: 150 },
      { label: '支付金额', prop: 'price', width: 100 },
      { label: '签约状态', prop: 'signStatus', width: 100 },
      { label: '所属部门', prop: 'deptName', width: 100 },
      { label: '所属员工', prop: 'empName', width: 100 },
      { label: '下单时间', prop: 'orderCreateTime', width: 150 },
      { label: '支付时间', prop: 'payTime', width: 150 },
      { label: '支付状态', prop: 'status', width: 100 },
      { label: '支付渠道', prop: 'channelCode', width: 120 },
      { label: '是否退款', prop: 'isRefund', width: 100 },
      { label: '退款金额', prop: 'refundAmount', width: 100 },
    ],
  },
  {
    key: 'sensitiveWordWarning',
    label: '敏感词预警',
    api: '/main/recordSensitiveWordsWarning/getPageWithAuthControl',
    exportApi: '/main/recordSensitiveWordsWarning/exportSensitiveWordsWarning',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户姓名', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '业务员工作账号', prop: 'empUserId', type: 'input' },
      { label: '所属组别', prop: 'deptName', type: 'input' },
      { label: '命中关键词', prop: 'hitKeywords', type: 'input' },
      {
        label: '未通话标识',
        prop: 'noCallBeforeDeadline',
        type: 'select',
        tooltip: '命中收费关键词当日24点前是否有通话',
        options: [
          { label: '未通话', value: 1 },
          { label: '有通话', value: 0 },
          { label: '非收费关键词', value: -1 },
        ]
      },
      { label: '消息时间', prop: 'msgTimeRange', type: 'dateRange' },
    ],
    tableColumns: [
      { label: '主体名称', prop: 'corpName', width: 100 },
      { label: '业务员姓名', prop: 'empName', width: 100 },
      { label: '业务员工作账号', prop: 'empUserId', width: 120 },
      { label: '所属组别', prop: 'deptName', width: 100 },
      { label: '客户姓名', prop: 'custName', width: 100 },
      { label: '头像', prop: 'avatar', width: 70 },
      { label: '消息类型', prop: 'msgType', width: 100 },
      { label: '消息内容', prop: 'msgContent', width: 200, showOverflowTooltip: true },
      { label: '消息时间', prop: 'msgTime', width: 150 },
      { label: '命中关键词', prop: 'hitKeywords', width: 120 },
      { label: '未通话标识', prop: 'noCallBeforeDeadline', width: 110, tooltip: '命中收费关键词当日24点前是否有通话' },
      { label: '首次通话时间', prop: 'firstCallTime', width: 140, tooltip: '命中收费关键词后首次通话时间' },
    ],
  },
  {
    key: 'callLiveNotReachStandard',
    label: '电话+直播不达标',
    api: '/main/recordCallLiveNotReachStandard/getPageWithAuthControl',
    exportApi: '/main/recordCallLiveNotReachStandard/exportCallLiveNotReach',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'deptName', type: 'input' },
      { label: '下组时间', prop: 'empCreatedTimeRange', type: 'dateRange' },
      {
        label: '电话数据考核标准',
        prop: 'phoneAssessmentFilter',
        type: 'select',
        options: [
          { label: '全部', value: '' },
          { label: '3个月以内', value: '3个月以内' },
          { label: '3个月以上', value: '3个月以上' },
          { label: '3个月以内，前一日开单1万及以上或上月业绩前10名', value: '3个月以内top' },
          { label: '3个月以上，前一日开单1万及以上或上月业绩前10名', value: '3个月以上top' },
        ]
      },
      {
        label: '直播+录播数据考核标准',
        prop: 'liveAssessmentFilter',
        type: 'select',
        options: [
          { label: '全部', value: '' },
          { label: '1个月以内业务员至少5个', value: '1个月以内业务员' },
          { label: '1-2个月业务员至少7个', value: '1-2个月业务员' },
          { label: '2-3个月业务员至少15个', value: '2-3个月业务员' },
          { label: '3个月以上业务员至少22个', value: '3个月以上业务员' }
        ]
      },
      {
        label: '未达标类型',
        prop: 'notReachType',
        type: 'select',
        options: [
          { label: '全部', value: '' },
          { label: '电话和直播均不达标', value: 'both' },
          { label: '仅电话不达标', value: 'call' },
          { label: '仅直播不达标', value: 'live' }
        ]
      },
    ],
    tableColumns: [
      { label: '业务员姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'deptName', width: 120 },
      { label: '下组时间', prop: 'empCreatedTime', width: 150 },
      { label: '上月业绩', prop: 'lastMonthAmount', width: 100 },
      { label: '前一日业绩', prop: 'yesterdayAmount', width: 100 },
      { label: '电话数据考核标准', prop: 'phoneAssessment', width: 180, showOverflowTooltip: true },
      { label: '前一日电话次数', prop: 'callCount', width: 140 },
      { label: '前一日电话总时长', prop: 'totalDuration', width: 160 },
      { label: '通话是否达标', prop: 'callIsReach', width: 120 },
      { label: '直播数据考核标准', prop: 'liveAssessment', width: 140 },
      { label: '直播+录播数据', prop: 'liveCustNum', width: 140 },
      { label: '直播是否达标', prop: 'liveIsReach', width: 120 },
    ],
  },
  {
    key: 'performanceSummary',
    label: '业绩汇总',
    api: '/inspect/empPerformance/querySummary',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'deptName', type: 'input' },
      { label: '业务员工作账号', prop: 'empUserId', type: 'input' },
      { label: '主体', prop: 'corpName', type: 'input' },
      {
        label: '业绩差值',
        prop: 'performanceDiffType',
        type: 'select',
        options: [
          { label: '全部', value: '' },
          { label: '大于0', value: 1 },
          { label: '小于0', value: 2 }
        ]
      },
    ],
    tableColumns: [
      { label: '组别', prop: 'deptName', width: 120 },
      { label: '业务员姓名', prop: 'empName', width: 120 },
      { label: '业务员工作账号', prop: 'empUserId', width: 140 },
      { label: '主体', prop: 'corpName', width: 140 },
      { label: '3个月内客户数', prop: 'custCount03', width: 130 },
      { label: '3-6个月客户数', prop: 'custCount36', width: 130 },
      { label: '6个月以上客户数', prop: 'custCount6Plus', width: 140 },
      { label: '上个月应出业绩', prop: 'expectedPerformance', width: 140 },
      { label: '上个月实际业绩', prop: 'actualPerformance', width: 140 },
      { label: '业绩差值(实际-应出)', prop: 'performanceDifference', width: 180 },
    ],
  },
  {
    key: 'customerRequestCheck',
    label: '客户索要资料检查数据',
    api: '/main/notAllowCustRequestForFirstDay/getPageWithAuthControl',
    exportApi: '/main/notAllowCustRequestForFirstDay/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'groupName', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      { label: '模型判断结果', prop: 'result', type: 'input' },
      {
        label: '是否有客户索要资料',
        prop: 'hasCustomerRequest',
        type: 'select',
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'batchDate', width: 110 },
      { label: '主体名称', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'custImage', width: 80 },
      { label: '客户昵称', prop: 'custName', width: 110 },
      { label: '员工姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'groupName', width: 120 },
      { label: '员工账号', prop: 'empCount', width: 90 },
      { label: '是否有客户索要资料', prop: 'hasCustomerRequest', width: 150 },
      { label: '客户索要资料类型', prop: 'customerRequestType', width: 150, showOverflowTooltip: true },
      { label: '客户索要内容', prop: 'customerRequestContent', width: 180, showOverflowTooltip: true },
      { label: '客户索要时间', prop: 'customerRequestTime', width: 150 },
      { label: '客服是否发送必需资料', prop: 'serviceSentRequiredMaterial', width: 170 },
      { label: '客服发送资料类型', prop: 'serviceSentType', width: 150, showOverflowTooltip: true },
      { label: '模型判断结果', prop: 'result', width: 130, showOverflowTooltip: true },
      { label: '判断原因', prop: 'reason', width: 200, showOverflowTooltip: true },
      { label: '置信度', prop: 'confidence', width: 90 },
    ],
  },
  {
    key: 'requiredTimeReplyCheck',
    label: '新资源五分钟内未发消息',
    api: '/main/notAllowCustRequestForFirstDay/getPageWithAuthControl',
    exportApi: '/main/notAllowCustRequestForFirstDay/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'groupName', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      {
        label: '是否规定时间内回复',
        prop: 'responseWithinRequiredTime',
        type: 'select',
        options: [
          { label: '满足', value: '满足' },
          { label: '不满足', value: '不满足' }
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'batchDate', width: 110 },
      { label: '主体名称', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'custImage', width: 80 },
      { label: '客户昵称', prop: 'custName', width: 110 },
      { label: '员工姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'groupName', width: 120 },
      { label: '员工账号', prop: 'empCount', width: 90 },
      { label: '客户添加时间', prop: 'customerAddTime', width: 150 },
      { label: '是否规定时间内回复', prop: 'responseWithinRequiredTime', width: 160 },
      { label: '客服第一条消息回复时间', prop: 'serviceFirstReplyTime', width: 180 },
    ],
  },
  {
    key: 'postMaterialQuestionCheck',
    label: '资料后是否有问句',
    api: '/main/notAllowCustRequestForFirstDay/getPageWithAuthControl',
    exportApi: '/main/notAllowCustRequestForFirstDay/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'groupName', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      {
        label: '发送资料后是否有问句',
        prop: 'postMaterialHasQuestion',
        type: 'select',
        options: [
          { label: '满足', value: '满足' },
          { label: '不满足', value: '不满足' },
          {label:'无资料',value:'无资料'}
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'batchDate', width: 110 },
      { label: '主体名称', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'custImage', width: 80 },
      { label: '客户昵称', prop: 'custName', width: 110 },
      { label: '员工姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'groupName', width: 120 },
      { label: '员工账号', prop: 'empCount', width: 90 },
      { label: '资料发送时间', prop: 'materialSendTime', width: 150 },
      { label: '资料发送内容', prop: 'materialSendContent', width: 180, showOverflowTooltip: true },
      { label: '发送资料后的回答', prop: 'postMaterialReplies', width: 180 },
      { label: '发送资料后是否有问句', prop: 'postMaterialHasQuestion', width: 170 },
    ],
  },
  {
    key: 'courseIntroAfterHandoverCheck',
    label: '承接后当天是否发送课程介绍',
    api: '/main/notAllowCustRequestForFirstDay/getPageWithAuthControl',
    exportApi: '/main/notAllowCustRequestForFirstDay/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'groupName', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      {
        label: '是否发送课程介绍',
        prop: 'hasCourseIntroAndLink',
        type: 'select',
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'batchDate', width: 110 },
      { label: '主体名称', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'custImage', width: 80 },
      { label: '客户昵称', prop: 'custName', width: 110 },
      { label: '员工姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'groupName', width: 120 },
      { label: '员工账号', prop: 'empCount', width: 90 },
      { label: '课程介绍和链接内容', prop: 'courseIntroAndLinkContent', width: 200, showOverflowTooltip: true },
      { label: '课程介绍和链接发送时间', prop: 'courseIntroAndLinkTime', width: 180 },
      { label: '承接当天是否发送课程介绍和链接', prop: 'hasCourseIntroAndLink', width: 220 },
    ],
  },
  {
    key: 'courseForeshadowingAfterHandoverCheck',
    label: '承接当天是否发送课程铺垫',
    api: '/main/notAllowCustRequestForFirstDay/getPageWithAuthControl',
    exportApi: '/main/notAllowCustRequestForFirstDay/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'groupName', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      {
        label: '承接当天是否发送课程铺垫',
        prop: 'hasCourseForeshadowing',
        type: 'select',
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'batchDate', width: 110 },
      { label: '主体名称', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'custImage', width: 80 },
      { label: '客户昵称', prop: 'custName', width: 110 },
      { label: '员工姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'groupName', width: 120 },
      { label: '员工账号', prop: 'empCount', width: 90 },
      { label: '课程铺垫聊天内容', prop: 'courseForeshadowingContent', width: 200, showOverflowTooltip: true },
      { label: '课程铺垫发送时间', prop: 'courseForeshadowingTime', width: 180 },
      { label: '承接当天是否发送课程铺垫', prop: 'hasCourseForeshadowing', width: 200 },
    ],
  },
  {
    key: 'fundAmountInquiryAfterHandoverCheck',
    label: '承接后当天是否询问资金量',
    api: '/main/notAllowCustRequestForFirstDay/getPageWithAuthControl',
    exportApi: '/main/notAllowCustRequestForFirstDay/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'custName', type: 'input' },
      { label: '业务员姓名', prop: 'empName', type: 'input' },
      { label: '所属组别', prop: 'groupName', type: 'input' },
      { label: '主体名称', prop: 'corpName', type: 'input' },
      {
        label: '是否询问资金量',
        prop: 'hasFundAmountInquiry',
        type: 'select',
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'batchDate', width: 110 },
      { label: '主体名称', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'custImage', width: 80 },
      { label: '客户昵称', prop: 'custName', width: 110 },
      { label: '员工姓名', prop: 'empName', width: 100 },
      { label: '所属组别', prop: 'groupName', width: 120 },
      { label: '员工账号', prop: 'empCount', width: 90 },
      { label: '资金量询问内容', prop: 'fundAmountInquiryContent', width: 200, showOverflowTooltip: true },
      { label: '资金量询问时间', prop: 'fundAmountInquiryTime', width: 150 },
      { label: '是否询问资金量', prop: 'hasFundAmountInquiry', width: 140 },
    ],
  },
  {
    key: 'customerResponseSlaCheck',
    label: '一小时内是否私聊检查',
    api: '/main/customerResponseSla/query',
    exportApi: '/main/customerResponseSla/export',
    exportBtn: true,
    exportBtnText: '导出',
    formItems: [
      { label: '客户昵称', prop: 'customerNickname', type: 'input' },
      { label: '所属组别', prop: 'employeeGroupName', type: 'input' },
      { label: '业务员姓名', prop: 'employeeName', type: 'input' },
      {
        label: '是否超时',
        prop: 'isViolation',
        type: 'select',
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
      {
        label: '近期有沟通',
        prop: 'hasRecentEmployeeMessage',
        type: 'select',
        tooltip: '客户消息前五分钟内是否存在业务员非群发消息',
        options: [
          { label: '是', value: 1 },
          { label: '否', value: 0 }
        ]
      },
    ],
    tableColumns: [
      { label: '检查日期', prop: 'reportDate', width: 110 },
      { label: '所属主体', prop: 'corpName', width: 120 },
      { label: '客户头像', prop: 'customerAvatar', width: 80 },
      { label: '客户昵称', prop: 'customerNickname', width: 110 },
      { label: '所属业务员', prop: 'employeeName', width: 110 },
      { label: '所属组别', prop: 'employeeGroupName', width: 120 },
      { label: '所属企微号', prop: 'employeeQwAccount', width: 130 },
      { label: '客户消息时间', prop: 'triggerTime', width: 160 },
      { label: '客户消息内容', prop: 'triggerContent', width: 220, showOverflowTooltip: true },
      { label: '近期有沟通', prop: 'hasRecentEmployeeMessage', width: 130, tooltip: '客户消息前五分钟内是否存在业务员非群发消息' },
      { label: '近期沟通时间', prop: 'recentEmployeeMessageTime', width: 160, tooltip: '客户消息前五分钟内最后一条业务员非群发消息时间' },
      { label: '首次有效私聊响应时间', prop: 'responseTime', width: 190 },
      { label: '是否超时未私聊回复', prop: 'isViolation', width: 170 },
      { label: '检查结果', prop: 'resultStatus', width: 150 },
    ],
  },

]);
// 3. 响应式数据
// 激活的 Tab
const activeTab = ref<string>(tabList.value[0].key);
// 表格数据（模拟）
const tableData = ref<any[]>([]);
// 当前表单数据（根据激活 Tab 动态生成）
const currentForm = ref<Record<string, any>>({});
// 4. 计算属性：获取当前激活 Tab 的配置
const currentTabConfig = computed(() => {
  return tabList.value.find((tab) => tab.key === activeTab.value);
});
// 字典数据配置
const dictOptions = {
  signStatus: [
    { value: 0, label: '未签约' },
    { value: 1, label: '已签约' }
  ],
  status: [
    { value: 0, label: '等待支付' },
    { value: 10, label: '支付成功' },
    { value: 20, label: '已退款' },
    { value: 30, label: '支付关闭' },
    { value: 40, label: '失败（三方订单不存在）' },
    { value: 50, label: '已过期（超过一周未完成支付）' }
  ],
  channelCode: [
    { value: 'wallet', label: '钱包' },
    { value: 'mock', label: '模拟支付' },
    { value: 'alipay_qr', label: '支付宝扫码支付' },
    { value: 'alipay_bar', label: '支付宝条码支付' },
    { value: 'alipay_app', label: '支付宝 App 支付' },
    { value: 'alipay_wap', label: '支付宝 Wap 网站支付' },
    { value: 'alipay_pc', label: '支付宝 PC 网站支付' },
    { value: 'wx_bar', label: '微信条码支付' },
    { value: 'wx_native', label: '微信扫码支付' },
    { value: 'wx_app', label: '微信 App 支付' },
    { value: 'wx_lite', label: '微信小程序支付' },
    { value: 'wx_pub', label: '微信公众号支付' },
    { value: 'wx_wap', label: '微信 Wap 网站支付' }
  ]
}

// 字典转义方法
const getDictName = (dictType: string, value: any) => {
  const options = dictOptions[dictType as keyof typeof dictOptions]
  if (!options || value === null || value === undefined) {
    return value || ''
  }
  const item = options.find((opt) => opt.value === value)
  return item ? item.label : value
}
const getNoCallBeforeDeadlineName = (value: any) => {
  if (value === 1 || value === '1') return '未通话'
  if (value === 0 || value === '0') return '有通话'
  if (value === -1 || value === '-1') return '非收费关键词'
  return value ?? ''
}
const getYesNoName = (value: any) => {
  if (value === 1 || value === '1') return '是'
  if (value === 0 || value === '0') return '否'
  return value ?? ''
}
const getResponseSlaStatusName = (value: string) => {
  const statusNames: Record<string, string> = {
    ON_TIME_RESPONSE: '一小时内响应',
    TIMEOUT_LATE_RESPONSE: '超时后响应',
    TIMEOUT_NO_RESPONSE: '超时未响应'
  }
  return statusNames[value] || value || '-'
}
const formatCustomerNickname = (value: any) => {
  if (value === null || value === undefined) return ''

  return String(value).replace(/1[3-9]\d{9}/g, (phone) => {
    return `${phone.slice(0, 3)}****${phone.slice(-4)}`
  })
}
const queryTypeByTab: Record<string, string> = {
  customerRequestCheck: 'hasCustomerRequest',
  requiredTimeReplyCheck: 'responseWithinRequiredTime',
  postMaterialQuestionCheck: 'hasQusetion',
  courseIntroAfterHandoverCheck: 'hasCourseIntroAndLink',
  courseForeshadowingAfterHandoverCheck: 'hasCourseForeshadowing',
  fundAmountInquiryAfterHandoverCheck: 'hasFundAmountInquiry',
}
const formatDateTime = (value: string) => {
  if (!value) return ''
  const matched = value.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2}:\d{2})/)
  if (matched) return `${matched[1]} ${matched[2]}`
  const date = dayjs(value)
  return date.isValid() ? date.format('YYYY-MM-DD HH:mm:ss') : value
}
const formatMultilineText = (value: any) => {
  if (value === null || value === undefined) return ''
  return String(value).replace(/\\n/g, '\n')
}
// 将秒数转换为分秒格式
const formatDuration = (seconds: number) => {
  if (!seconds || seconds === 0) return '0s'
  const minutes = Math.floor(seconds / 60)
  const secs = seconds % 60

  let result = ''
  if (minutes > 0) result += `${minutes}m`
  if (secs > 0 || !result) result += `${secs}s`

  return result
}
// 格式化业绩数据（添加千分位分隔符）
const formatPerformance = (value: number | null | undefined) => {
  if (value === null || value === undefined) return '0'
  return Number(value).toLocaleString()
}
// 格式化交接时间，提取月日
const formatHandoverTime = (handoverTime: string) => {
  if (!handoverTime) return ''
  const date = dayjs(handoverTime)
  const month = date.format('MM')
  const day = date.format('DD')
  return `${month}${day}交接`
}
const page = ref({
  pageNo: 1,
  pageSize: 10,
  total: 0
})
const callStatistics=ref({} as any)
// 树形表格数据
const treeTableData = ref<any[]>([])
// 原始数据
const originalTableData = ref<any[]>([])
// 表格引用
const tableRef = ref<any>(null)
let loadingInstance: ILoadingInstance = {} as ILoadingInstance

const getDept = async () => {
  let deptList = await getListData('/main/resourceAnalysis/getTop13DepartmentListByDeptSort', {})
  const deptOptions = deptList.map((item: any) => {
    return {title: item.name, value: item.name};
  })
  const item = tabList.value.find(
    (item) => item.key === 'yesterdaySeeLive'
  )
  const deptItem = item!.formItems.find(
    (item) => item.prop === 'deptName'
  )
  deptItem!.options = deptOptions
}
// getDept()
// Tab 切换时重置表单
const handleTabChange = () => {
  resetForm();
};

// 重置表单
const resetForm = () => {
  if (!currentTabConfig.value) return;
  // 清空当前表单所有字段
  currentForm.value = currentTabConfig.value.formItems.reduce((obj, item) => {
    obj[item.prop] = '';
    return obj;
  }, {} as Record<string, any>);

  // 如果是30天内累计观看大于10天的客户页面，默认查询未成交（isDealt=0）
  if (currentTabConfig.value.key === '30daysOver10') {
    currentForm.value.isDealt = 0;
  }

  // 客户索要资料检查数据默认查询模型判断结果为“不满足”
  if (currentTabConfig.value.key === 'customerRequestCheck') {
    currentForm.value.result = '不满足';
  }

  // 新资源五分钟内未发消息默认查询“不满足”
  if (currentTabConfig.value.key === 'requiredTimeReplyCheck') {
    currentForm.value.responseWithinRequiredTime = '不满足';
  }

  // 资料后是否有问句默认查询“不满足”
  if (currentTabConfig.value.key === 'postMaterialQuestionCheck') {
    currentForm.value.postMaterialHasQuestion = '不满足';
  }

  // 承接后当天是否发送课程介绍默认查询“否”
  if (currentTabConfig.value.key === 'courseIntroAfterHandoverCheck') {
    currentForm.value.hasCourseIntroAndLink = 0;
  }

  // 承接当天是否发送课程铺垫默认查询“否”
  if (currentTabConfig.value.key === 'courseForeshadowingAfterHandoverCheck') {
    currentForm.value.hasCourseForeshadowing = 0;
  }

  // 承接后当天是否询问资金量默认查询“否”
  if (currentTabConfig.value.key === 'fundAmountInquiryAfterHandoverCheck') {
    currentForm.value.hasFundAmountInquiry = 0;
  }

  // 一小时内是否私聊检查默认查询超时记录
  if (currentTabConfig.value.key === 'customerResponseSlaCheck') {
    currentForm.value.isViolation = 1;
  }

  // 如果是敏感词预警页面，初始化消息时间为查询日期前一天的时间段
  if (currentTabConfig.value.key === 'sensitiveWordWarning' && currentRow.value?.date) {
    const queryDate = dayjs(currentRow.value.date);
    const previousDate = queryDate.subtract(1, 'day');
    const dateStr = previousDate.format('YYYY-MM-DD');
    currentForm.value.msgTimeRange = [
      `${dateStr} 00:00:00`,
      `${dateStr} 23:59:59`
    ];
  }

  page.value.pageNo=1
  loadTableData();
};

// 禁用消息时间选择器的日期
const disabledMsgTime = (time: Date) => {
  if (!currentRow.value?.date) return false;
  const queryDate = dayjs(currentRow.value.date);
  const previousDate = queryDate.subtract(1, 'day');
  const currentTime = dayjs(time);
  // 只允许选择查询日期前一天
  return !currentTime.isSame(previousDate, 'day');
};

// 查询方法
const handleSearch = () => {
  // 这里可对接后端接口，传入 currentForm.value 和 activeTab.value 查询数据
  console.log('查询条件：', currentForm.value, 'Tab：', activeTab.value);
  page.value.pageNo = 1
  loadTableData(); // 模拟查询后加载数据
};
const handleSizeChange = (pageSize: number) => {
  page.value.pageSize = pageSize
  loadTableData()
}
const handleCurrentChange = (pageNo: number) => {
  page.value.pageNo = pageNo
  loadTableData()
}
// 导出功能
const handleExport = async () => {
  if (!currentTabConfig.value) return;

  // 业绩汇总使用前端导出
  if (currentTabConfig.value.key === 'performanceSummary') {
    if (!tableData.value || tableData.value.length === 0) {
      ElMessage.warning('暂无数据可导出');
      return;
    }

    try {
      const lastMonth = dayjs(currentRow.value.date).subtract(1, 'month');
      const lastMonthStr = lastMonth.format('YYYY-MM');
      await exportToFrontendExcel(lastMonthStr);
    } catch (error) {
      console.error('导出失败:', error);
      ElMessage.error('导出失败，请重试');
    }
    return;
  }

  // 其他Tab使用后端导出
  if (!currentTabConfig.value.exportApi) {
    ElMessage.warning('该Tab暂未配置导出接口');
    return;
  }

  let loadingInstance: any = null;
  try {
    loadingInstance = ElLoading.service({
      lock: true,
      text: '数据导出中...',
      background: 'rgba(0, 0, 0, 0.7)'
    });

    let params: any = {
      sysDate: currentRow.value.date
    };
    const queryType = queryTypeByTab[currentTabConfig.value.key];
    if (queryType) {
      params.queryType = queryType;
    }

    // 根据不同的Tab添加对应的查询参数
    if (currentTabConfig.value.key === 'yesterdayWatch') {
      // 前一日观看直播客户
      if (currentForm.value.consumerNickName) {
        params.consumerNickName = currentForm.value.consumerNickName;
      }
      if (currentForm.value.consumerWxUnionId) {
        params.consumerWxUnionId = currentForm.value.consumerWxUnionId;
      }
      if (currentForm.value.isDealt !== '' && currentForm.value.isDealt !== undefined && currentForm.value.isDealt !== null) {
        params.isDealt = currentForm.value.isDealt;
      }
    } else if (currentTabConfig.value.key === '30daysOver10') {
      // 30天内累计观看大于10天的客户
      if (currentForm.value.custNickName) {
        params.custNickName = currentForm.value.custNickName;
      }
      if (currentForm.value.unionid) {
        params.unionid = currentForm.value.unionid;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.isDealt !== '' && currentForm.value.isDealt !== undefined && currentForm.value.isDealt !== null) {
        params.isDealt = currentForm.value.isDealt;
      }
    } else if (currentTabConfig.value.key === 'yesterdayNoReply') {
      // 前一日未回复客户
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.custUnionid) {
        params.custUnionid = currentForm.value.custUnionid;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.empUserId) {
        params.empUserId = currentForm.value.empUserId;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
    } else if (currentTabConfig.value.key === 'yesterdaySeeLive') {
      // 前一日观看录播超过3分钟客户
      if (currentForm.value.consumerNickName) {
        params.consumerNickName = currentForm.value.consumerNickName;
      }
      if (currentForm.value.deptName) {
        params.deptName = currentForm.value.deptName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
    } else if (currentTabConfig.value.key === 'weekNoGroup') {
      // 近一周不允许拉群客户
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.consumerWxUnionId) {
        params.consumerWxUnionId = currentForm.value.consumerWxUnionId;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
    } else if (currentTabConfig.value.key === 'dayNeedContact') {
      // 新资源承接需联系列表
      if (currentForm.value.unionid) {
        params.unionid = currentForm.value.unionid;
      }
      if (currentForm.value.custNickName) {
        params.custNickName = currentForm.value.custNickName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
    } else if (currentTabConfig.value.key === 'weekCallLessOrTimeLess') {
      // 本月通话次数和时长统计
      if (currentForm.value.usedBy) {
        params.usedBy = currentForm.value.usedBy;
      }
    } else if (currentTabConfig.value.key === 'duplicateResourceTransaction') {
      // 重复资源成交客户
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.custUnionid) {
        params.custUnionid = currentForm.value.custUnionid;
      }
      if (currentForm.value.succEmpName) {
        params.succEmpName = currentForm.value.succEmpName;
      }
      if (currentForm.value.otherEmpName) {
        params.otherEmpName = currentForm.value.otherEmpName;
      }
    } else if (currentTabConfig.value.key === 'liveDepositOrder') {
      // 直播间定金订单客户信息
      if (currentForm.value.productName) {
        params.productName = currentForm.value.productName;
      }
      if (currentForm.value.nickname) {
        params.nickname = currentForm.value.nickname;
      }
      if (currentForm.value.unionid) {
        params.unionid = currentForm.value.unionid;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.signStatus !== '' && currentForm.value.signStatus !== undefined && currentForm.value.signStatus !== null) {
        params.signStatus = currentForm.value.signStatus;
      }
      if (currentForm.value.status !== '' && currentForm.value.status !== undefined && currentForm.value.status !== null) {
        params.status = currentForm.value.status;
      }
    } else if (currentTabConfig.value.key === 'sensitiveWordWarning') {
      // 敏感词预警
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.empUserId) {
        params.empUserId = currentForm.value.empUserId;
      }
      if (currentForm.value.deptName) {
        params.deptName = currentForm.value.deptName;
      }
      if (currentForm.value.hitKeywords) {
        params.hitKeywords = currentForm.value.hitKeywords;
      }
      if (currentForm.value.noCallBeforeDeadline !== '' && currentForm.value.noCallBeforeDeadline !== undefined && currentForm.value.noCallBeforeDeadline !== null) {
        params.noCallBeforeDeadline = currentForm.value.noCallBeforeDeadline;
      }
      if (currentForm.value.msgTimeStart) {
        params.msgTimeStart = currentForm.value.msgTimeStart;
      }
      if (currentForm.value.msgTimeEnd) {
        params.msgTimeEnd = currentForm.value.msgTimeEnd;
      }
    } else if (currentTabConfig.value.key === 'callLiveNotReachStandard') {
      // 电话+直播不达标
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.deptName) {
        params.deptName = currentForm.value.deptName;
      }
      if (currentForm.value.empCreatedTimeStart) {
        params.empCreatedTimeStart = currentForm.value.empCreatedTimeStart;
      }
      if (currentForm.value.empCreatedTimeEnd) {
        params.empCreatedTimeEnd = currentForm.value.empCreatedTimeEnd;
      }
      if (currentForm.value.phoneDataMonthType) {
        params.phoneDataMonthType = currentForm.value.phoneDataMonthType;
      }
      if (currentForm.value.isTopPerformance !== undefined && currentForm.value.isTopPerformance !== null) {
        params.isTopPerformance = currentForm.value.isTopPerformance;
      }
      if (currentForm.value.liveDataMonthType) {
        params.liveDataMonthType = currentForm.value.liveDataMonthType;
      }
      if (currentForm.value.notReachType) {
        params.notReachType = currentForm.value.notReachType;
      }
    } else if (currentTabConfig.value.key === 'customerRequestCheck') {
      // 客户索要资料检查数据
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.result) {
        params.result = currentForm.value.result;
      }
      if (currentForm.value.hasCustomerRequest !== '' && currentForm.value.hasCustomerRequest !== undefined && currentForm.value.hasCustomerRequest !== null) {
        params.hasCustomerRequest = currentForm.value.hasCustomerRequest;
      }
    } else if (currentTabConfig.value.key === 'requiredTimeReplyCheck') {
      // 新资源五分钟内未发消息
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.responseWithinRequiredTime !== '' && currentForm.value.responseWithinRequiredTime !== undefined && currentForm.value.responseWithinRequiredTime !== null) {
        params.responseWithinRequiredTime = currentForm.value.responseWithinRequiredTime;
      }
    } else if (currentTabConfig.value.key === 'postMaterialQuestionCheck') {
      // 资料后是否有问句
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.postMaterialHasQuestion) {
        params.postMaterialHasQuestion = currentForm.value.postMaterialHasQuestion;
      }
    } else if (currentTabConfig.value.key === 'courseIntroAfterHandoverCheck') {
      // 承接后当天是否发送课程介绍
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.hasCourseIntroAndLink !== '' && currentForm.value.hasCourseIntroAndLink !== undefined && currentForm.value.hasCourseIntroAndLink !== null) {
        params.hasCourseIntroAndLink = currentForm.value.hasCourseIntroAndLink;
      }
    } else if (currentTabConfig.value.key === 'courseForeshadowingAfterHandoverCheck') {
      // 承接当天是否发送课程铺垫
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.hasCourseForeshadowing !== '' && currentForm.value.hasCourseForeshadowing !== undefined && currentForm.value.hasCourseForeshadowing !== null) {
        params.hasCourseForeshadowing = currentForm.value.hasCourseForeshadowing;
      }
    } else if (currentTabConfig.value.key === 'fundAmountInquiryAfterHandoverCheck') {
      // 承接后当天是否询问资金量
      if (currentForm.value.custName) {
        params.custName = currentForm.value.custName;
      }
      if (currentForm.value.empName) {
        params.empName = currentForm.value.empName;
      }
      if (currentForm.value.groupName) {
        params.groupName = currentForm.value.groupName;
      }
      if (currentForm.value.corpName) {
        params.corpName = currentForm.value.corpName;
      }
      if (currentForm.value.hasFundAmountInquiry !== '' && currentForm.value.hasFundAmountInquiry !== undefined && currentForm.value.hasFundAmountInquiry !== null) {
        params.hasFundAmountInquiry = currentForm.value.hasFundAmountInquiry;
      }
    } else if (currentTabConfig.value.key === 'customerResponseSlaCheck') {
      params.reportDate = currentRow.value.date;
      delete params.sysDate;
      if (currentForm.value.customerNickname) {
        params.customerNickname = currentForm.value.customerNickname;
      }
      if (currentForm.value.employeeGroupName) {
        params.employeeGroupName = currentForm.value.employeeGroupName;
      }
      if (currentForm.value.employeeName) {
        params.employeeName = currentForm.value.employeeName;
      }
      if (currentForm.value.isViolation !== '' && currentForm.value.isViolation !== undefined && currentForm.value.isViolation !== null) {
        params.isViolation = currentForm.value.isViolation;
      }
      if (currentForm.value.hasRecentEmployeeMessage !== '' && currentForm.value.hasRecentEmployeeMessage !== undefined && currentForm.value.hasRecentEmployeeMessage !== null) {
        params.hasRecentEmployeeMessage = currentForm.value.hasRecentEmployeeMessage;
      }
    }


    console.log('导出接口:', currentTabConfig.value.exportApi);
    console.log('导出参数:', params);

    // 使用 GET 请求调用后端导出接口
    const res = await downloadData(
      currentTabConfig.value.exportApi,
      params,
      'blob'
    );

    console.log('导出接口返回:', res);
    console.log('返回数据类型:', typeof res);
    console.log('是否为Blob:', res instanceof Blob);

    // 检查返回的是否是文件流
    if (res instanceof Blob) {
      const blob = new Blob([res], {
        type: 'application/octet-stream'
      });

      const down = document.createElement('a');
      const fileName = `${currentTabConfig.value.label}_${currentRow.value.date}.xlsx`;
      down.download = fileName;
      down.style.display = 'none';
      down.href = URL.createObjectURL(blob);
      document.body.appendChild(down);
      down.click();
      URL.revokeObjectURL(down.href);
      document.body.removeChild(down);

      ElMessage.success('导出成功');
    } else {
      // 如果返回的不是Blob，说明后端可能返回了JSON错误信息
      console.warn('后端返回的不是文件流，返回内容:', res);
      ElMessage.warning('导出失败，请检查后端接口');
    }
  } catch (error) {
    console.error('导出失败:', error);
    ElMessage.error('导出失败，请重试');
  } finally {
    // 确保无论成功还是失败都关闭loading
    if (loadingInstance && typeof loadingInstance.close === 'function') {
      loadingInstance.close();
      console.log('loading已关闭');
    }
  }
};

// 前端生成Excel文件
const exportToFrontendExcel = async (lastMonthStr: string) => {
  try {
    // 动态导入xlsx库
    const XLSX = await import('xlsx');

    // 使用原始数据（接口返回的所有数据）而不是树形表格数据
    const exportData = originalTableData.value

    if (!exportData || exportData.length === 0) {
      ElMessage.warning('暂无数据可导出');
      return;
    }

    // 准备表头
    const headers = currentTabConfig.value!.tableColumns.map(col => col.label);
    const props = currentTabConfig.value!.tableColumns.map(col => col.prop);

    console.log('导出表头:', headers);
    console.log('导出字段:', props);
    console.log('导出原始数据:', exportData);

    // 转换数据
    const data = exportData.map((row: any) => {
      const rowData: any = {};
      props.forEach((prop, index) => {
        let value = row[prop];

        // 处理特殊字段
        if (prop === 'deptName') {
          // 部门类型显示 ">" 符号
          if (row.dataType === 'dept') {
            value = value ? value + '>' : '';
          }
        } else if (prop === 'empName') {
          // 部门类型显示 "--"
          if (row.dataType === 'dept') {
            value = '--';
          } else if (!value) {
            value = '--';
          }
        } else if (prop === 'empUserId') {
          // 部门和业务员类型显示 "--"
          if (row.dataType === 'dept' || row.dataType === 'emp') {
            value = '--';
          } else if (row.groupName) {
            value = `${row.empUserId}(${row.groupName})`;
          } else if (row.handoverTime) {
            value = `${row.empUserId}(${formatHandoverTime(row.handoverTime)})`;
          }
        } else if (prop === 'expectedPerformance' || prop === 'actualPerformance' || prop === 'performanceDifference') {
          // 业绩字段默认显示 0
          if (value === null || value === undefined) {
            value = 0;
          }
        }

        // 处理空值
        if (value === null || value === undefined) {
          value = '';
        }

        rowData[headers[index]] = value;
      });
      return rowData;
    });

    console.log('转换后的导出数据:', data);

    // 创建工作簿
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '业绩汇总');

    // 导出文件
    XLSX.writeFile(wb, `业绩汇总_${lastMonthStr}.xlsx`);

    ElMessage.success('导出成功');
  } catch (error) {
    console.error('前端导出失败:', error);
    ElMessage.error('导出失败，请重试');
  }
};
const emit = __emit;
function closePop () {
  dialogVisible.value = false
  emit('close')
}
// 加载表格数据（模拟）
const loadTableData = async() => {
  if (!currentTabConfig.value?.api) return;

  console.log('开始加载数据，Tab:', currentTabConfig.value.key);
  console.log('查询参数:', currentForm.value);

  if (document.querySelector('.contLoading')) {
    if (loadingInstance && typeof loadingInstance.close == 'function') {
      loadingInstance.close()
    }
    loadingInstance = ElLoading.service({
      target: '.contLoading',
      text: '加载中....',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.8)',
      fullscreen: false
    })
  }
  try {
    let obj = {
      pageNo: page.value.pageNo,
      pageSize: page.value.pageSize,
      sysDate: currentRow.value.date
    }
    let params = {...currentForm.value, ...obj}

    if (currentTabConfig.value.key === 'customerResponseSlaCheck') {
      params.reportDate = currentRow.value.date
      delete params.sysDate
    }

    if (currentForm.value.msgTimeRange && currentForm.value.msgTimeRange.length === 2) {
      params.msgTimeStart = currentForm.value.msgTimeRange[0]
      params.msgTimeEnd = currentForm.value.msgTimeRange[1]
      delete params.msgTimeRange
    }

    if (currentForm.value.empCreatedTimeRange && currentForm.value.empCreatedTimeRange.length === 2) {
      params.empCreatedTimeStart = dayjs(currentForm.value.empCreatedTimeRange[0]).format('YYYY-MM-DD')
      params.empCreatedTimeEnd = dayjs(currentForm.value.empCreatedTimeRange[1]).format('YYYY-MM-DD')
      delete params.empCreatedTimeRange
    }

    // 处理电话数据考核标准筛选
    if (currentForm.value.phoneAssessmentFilter) {
      const filterValue = currentForm.value.phoneAssessmentFilter
      if (filterValue.includes('3个月以内')) {
        params.phoneDataMonthType = '3个月以内'
      } else {
        params.phoneDataMonthType = '3个月以上'
      }
      params.isTopPerformance = 0
      if (filterValue.includes('top')) {
        params.isTopPerformance = 1
      }
      delete params.phoneAssessmentFilter
    }

    // 处理直播数据考核标准筛选
    if (currentForm.value.liveAssessmentFilter) {
      params.liveDataMonthType = currentForm.value.liveAssessmentFilter
      delete params.liveAssessmentFilter
    }

    const queryType = queryTypeByTab[currentTabConfig.value.key]
    if (queryType) {
      params.queryType = queryType
    }

    // 处理业绩汇总Tab的特殊逻辑
    if (currentTabConfig.value.key === 'performanceSummary') {
      // 业绩汇总不需要分页
      delete params.pageNo
      delete params.pageSize
      console.log('业绩汇总查询参数:', params);
    }

    console.log('调用接口:', currentTabConfig.value.api, '参数:', params);
    const res = await getListData(currentTabConfig.value.api, params)
    console.log('接口返回数据:', res);
    console.log('res.data:', res.data);
    console.log('res.data 是否为数组:', Array.isArray(res.data));

    if(res) {
      // 业绩汇总接口返回的数据结构是 {code: 200, message: "操作成功", data: [...]}
      if (currentTabConfig.value.key === 'performanceSummary') {
        // 直接使用 res，因为 getListData 可能已经解包了 data 字段
        let rawData = []
        if (Array.isArray(res)) {
          // 如果 res 本身就是数组
          rawData = res
        } else if (res.data && Array.isArray(res.data)) {
          // 如果 res 是对象，包含 data 字段
          rawData = res.data
        } else {
          rawData = []
        }

        // 保存原始数据
        originalTableData.value = rawData

        // 构建树形结构
        treeTableData.value = buildTreeData(rawData)

        tableData.value = treeTableData.value
        page.value.total = treeTableData.value.length
      } else {
        const pageData = res?.data && !res.records && !res.list ? res.data : res
        tableData.value = pageData?.records ? pageData.records : pageData?.list ? pageData.list : []
        page.value.total = Number(pageData?.total || 0)
      }
      console.log('表格数据赋值完成:', tableData.value);
      console.log('表格数据长度:', tableData.value.length);
    } else {
      console.warn('接口返回数据为空');
      tableData.value = [];
    }
  } catch (error) {
    console.error('加载数据失败:', error);
    tableData.value = []
  } finally {
    if (loadingInstance && typeof loadingInstance.close == 'function') {
      loadingInstance.close()
    }
  }
};

// 弹窗相关数据
const dialogVisible = ref(false)
const currentRow = ref<any>(null)
const title = ref('')
/** 打开弹窗 */
const open = async (row:any) => {
  dialogVisible.value = true
  currentRow.value = row
  title.value = currentRow.value.date + '通知记录'
  // 初始化
  resetForm();
}

// 构建树形数据结构
const buildTreeData = (data: any[]) => {
  // 1. 按 dataType 分组
  const depts = data.filter(item => item.dataType === 'dept')
  const emps = data.filter(item => item.dataType === 'emp')
  const accounts = data.filter(item => item.dataType === 'account')

  // 2. 为每个节点生成唯一 ID
  const generateId = (item: any, index: number) => {
    return `${item.dataType}_${index}`
  }

  // 3. 如果有部门数据，构建部门 -> 业务员 -> 账号的树形结构
  if (depts.length > 0) {
    const treeData = depts.map((dept, deptIndex) => {
      const deptId = generateId(dept, deptIndex)

      // 找到该部门下的所有业务员
      const deptEmps = emps.filter(emp => emp.deptName === dept.deptName)

      const children = deptEmps.map((emp, empIndex) => {
        const empId = generateId(emp, empIndex)

        // 找到该业务员下的所有账号
        const empAccounts = accounts.filter(account =>
          account.empName === emp.empName && account.deptName === emp.deptName
        )

        return {
          ...emp,
          id: empId,
          children: empAccounts.map((account, accountIndex) => ({
            ...account,
            id: generateId(account, accountIndex)
          }))
        }
      })

      return {
        ...dept,
        id: deptId,
        children: children
      }
    })

    return treeData
  } else {
    // 4. 如果没有部门数据（业务员视角），构建业务员 -> 账号的树形结构
    const treeData = emps.map((emp, empIndex) => {
      const empId = generateId(emp, empIndex)

      // 找到该业务员下的所有账号
      const empAccounts = accounts.filter(account =>
        account.empName === emp.empName && account.deptName === emp.deptName
      )

      return {
        ...emp,
        id: empId,
        children: empAccounts.map((account, accountIndex) => ({
          ...account,
          id: generateId(account, accountIndex)
        }))
      }
    })

    return treeData
  }
}

// 一键展开所有节点
const expandAll = () => {
  if (!tableRef.value) return

  // 递归展开所有行
  const expandRows = (rows: any[]) => {
    rows.forEach(row => {
      tableRef.value.toggleRowExpansion(row, true)
      if (row.children && row.children.length > 0) {
        expandRows(row.children)
      }
    })
  }

  expandRows(treeTableData.value)
}

// 一键收起所有节点，只保留部门层级
const collapseAll = () => {
  if (!tableRef.value) return

  // 递归收起所有行
  const collapseRows = (rows: any[]) => {
    rows.forEach(row => {
      tableRef.value.toggleRowExpansion(row, false)
      if (row.children && row.children.length > 0) {
        collapseRows(row.children)
      }
    })
  }

  collapseRows(treeTableData.value)
}

__expose({ open }) // 提供 open 方法，用于打开弹窗

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: dialogVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
    fullscreen: true,
    "show-close": false
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(title.value), 1),
        _createVNode(_unref(ElButton), {
          type: "danger",
          icon: "el-icon-close",
          size: "small",
          onClick: closePop,
          style: {"position":"absolute","top":"0","right":"10px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 关闭 ")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_unref(ElRadioGroup), {
          modelValue: activeTab.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
          fill: "#409eff",
          onChange: handleTabChange
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (tab) => {
              return (_openBlock(), _createBlock(_unref(ElRadioButton), {
                key: tab.key,
                label: tab.key
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tab.label), 1)
                ]),
                _: 2
              }, 1032, ["label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (currentTabConfig.value?.formItems?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_el_form, {
                model: currentForm.value,
                inline: "",
                onSubmit: _withModifiers(handleSearch, ["prevent"]),
                class: "mb-4"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTabConfig.value.formItems, (formItem) => {
                    return (_openBlock(), _createBlock(_component_el_form_item, {
                      key: formItem.prop,
                      label: formItem.label
                    }, _createSlots({
                      default: _withCtx(() => [
                        (formItem.type === 'input')
                          ? (_openBlock(), _createBlock(_component_el_input, {
                              key: 0,
                              modelValue: currentForm.value[formItem.prop],
                              "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                              placeholder: `请输入${formItem.label}`,
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                          : (formItem.type === 'select')
                            ? (_openBlock(), _createBlock(_component_el_select, {
                                key: 1,
                                modelValue: currentForm.value[formItem.prop],
                                "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                placeholder: `请选择${formItem.label}`,
                                clearable: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formItem.options || [], (option) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: option.value,
                                      label: option.label,
                                      value: option.value
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                            : (formItem.type === 'date')
                              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                  key: 2,
                                  modelValue: currentForm.value[formItem.prop],
                                  "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                  type: "date",
                                  placeholder: `请选择${formItem.label}`,
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              : (formItem.type === 'dateRange')
                                ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                    key: 3,
                                    modelValue: currentForm.value[formItem.prop],
                                    "onUpdate:modelValue": ($event: any) => ((currentForm.value[formItem.prop]) = $event),
                                    type: "daterange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始时间",
                                    "end-placeholder": "结束时间",
                                    format: "YYYY-MM-DD HH:mm:ss",
                                    "value-format": "YYYY-MM-DD HH:mm:ss",
                                    "disabled-date": currentTabConfig.value?.key === 'sensitiveWordWarning' ? disabledMsgTime : undefined,
                                    clearable: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled-date"]))
                                : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, [
                      (formItem.tooltip)
                        ? {
                            name: "label",
                            fn: _withCtx(() => [
                              _createElementVNode("span", _hoisted_7, [
                                _createTextVNode(_toDisplayString(formItem.label) + " ", 1),
                                _createVNode(_unref(ElTooltip), {
                                  effect: "dark",
                                  content: formItem.tooltip,
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_8
                                  ]),
                                  _: 2
                                }, 1032, ["content"])
                              ])
                            ]),
                            key: "0"
                          }
                        : undefined
                    ]), 1032, ["label"]))
                  }), 128)),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ElButton), {
                        type: "primary",
                        onClick: handleSearch
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(ElButton), { onClick: resetForm }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      }),
                      (currentTabConfig.value?.exportBtn)
                        ? (_openBlock(), _createBlock(_unref(ElButton), {
                            key: 0,
                            type: "success",
                            onClick: handleExport
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(currentTabConfig.value.exportBtnText || '导出'), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        (currentTabConfig.value?.key === 'callLiveNotReachStandard')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_unref(ElTooltip), {
                effect: "dark",
                placement: "top",
                "show-after": 200,
                "popper-class": "custom-tooltip"
              }, {
                content: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 1
              }),
              _hoisted_12
            ]))
          : _createCommentVNode("", true),
        (currentTabConfig.value?.key === 'performanceSummary')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createVNode(_unref(ElTooltip), {
                effect: "dark",
                placement: "top",
                "show-after": 200,
                "popper-class": "custom-tooltip"
              }, {
                content: _withCtx(() => [
                  _hoisted_14
                ]),
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _hoisted_16
            ]))
          : _createCommentVNode("", true),
        (currentTabConfig.value?.tableColumns?.length && (currentTabConfig.value?.key == 'weekCallLessOrTimeLess' ? !isEmp.value : true))
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (currentTabConfig.value?.key === 'performanceSummary')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      size: "small",
                      onClick: expandAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("一键展开")
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      type: "primary",
                      size: "small",
                      onClick: collapseAll
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("一键收起")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_table, {
                ref_key: "tableRef",
                ref: tableRef,
                data: currentTabConfig.value?.key === 'performanceSummary' ? treeTableData.value : tableData.value,
                "tree-props": currentTabConfig.value?.key === 'performanceSummary' ? { children: 'children', hasChildren: 'hasChildren' } : undefined,
                "row-key": "id",
                border: "",
                stripe: "",
                style: {"width":"100%"},
                "max-height": "500"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTabConfig.value.tableColumns, (column) => {
                    return (_openBlock(), _createBlock(_component_el_table_column, {
                      key: column.prop,
                      prop: column.prop,
                      label: column.label,
                      "min-width": column.width,
                      "show-overflow-tooltip": column.showOverflowTooltip
                    }, _createSlots({ _: 2 }, [
                      (column.tooltip)
                        ? {
                            name: "header",
                            fn: _withCtx(() => [
                              _createElementVNode("span", _hoisted_19, [
                                _createTextVNode(_toDisplayString(column.label) + " ", 1),
                                _createVNode(_unref(ElTooltip), {
                                  effect: "dark",
                                  content: column.tooltip,
                                  placement: "top"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_20
                                  ]),
                                  _: 2
                                }, 1032, ["content"])
                              ])
                            ]),
                            key: "0"
                          }
                        : undefined,
                      (column.prop === 'phoneAssessment')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("div", null, _toDisplayString(scope.row.phoneDataMonthType), 1),
                                (scope.row.isTopPerformance === 1 && scope.row.yesterdayAmount >= 10000)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " 前一日开单1万及以上 "))
                                  : (scope.row.isTopPerformance === 1 && scope.row.yesterdayAmount < 10000)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, " 上月业绩前10名 "))
                                    : _createCommentVNode("", true)
                              ])
                            ]),
                            key: "1"
                          }
                        : undefined,
                      (column.prop === 'liveAssessment')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("div", null, _toDisplayString(scope.row.liveDataMonthType), 1)
                            ]),
                            key: "2"
                          }
                        : undefined,
                      (column.prop === 'callCount')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ color: scope.row.callCount < scope.row.callStandardCount ? '#f56c6c' : '' })
                              }, _toDisplayString(scope.row.callCount || 0), 5),
                              _createElementVNode("span", _hoisted_24, " (" + _toDisplayString(scope.row.callStandardCount || 0) + ")", 1)
                            ]),
                            key: "3"
                          }
                        : undefined,
                      (column.prop === 'totalDuration')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ color: scope.row.totalDuration < scope.row.callStandardDuration ? '#f56c6c' : '' })
                              }, _toDisplayString(formatDuration(scope.row.totalDuration)), 5),
                              _createElementVNode("span", _hoisted_25, " (" + _toDisplayString(formatDuration(scope.row.callStandardDuration)) + ")", 1)
                            ]),
                            key: "4"
                          }
                        : undefined,
                      (column.prop === 'liveCustNum')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ color: scope.row.totalCustNum < scope.row.liveStandardCustNum ? '#f56c6c' : '' })
                              }, _toDisplayString(scope.row.totalCustNum || 0), 5),
                              _createElementVNode("span", _hoisted_26, " (" + _toDisplayString(scope.row.liveStandardCustNum || 0) + ")", 1)
                            ]),
                            key: "5"
                          }
                        : undefined,
                      (column.prop === 'callIsReach')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.callIsReach === 1 ? '是' : '否'), 1)
                            ]),
                            key: "6"
                          }
                        : undefined,
                      (column.prop === 'liveIsReach')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.liveIsReach === 1 ? '是' : '否'), 1)
                            ]),
                            key: "7"
                          }
                        : undefined,
                      (column.prop === 'notReachType')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.notReachType === 'both' ? '电话和直播均不达标' : scope.row.notReachType === 'call' ? '仅电话不达标' : scope.row.notReachType === 'live' ? '仅直播不达标' : scope.row.notReachType), 1)
                            ]),
                            key: "8"
                          }
                        : undefined,
                      (column.prop === 'noCallBeforeDeadline')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getNoCallBeforeDeadlineName(scope.row.noCallBeforeDeadline)), 1)
                            ]),
                            key: "9"
                          }
                        : undefined,
                      (column.prop === 'hasCustomerRequest')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getYesNoName(scope.row.hasCustomerRequest)), 1)
                            ]),
                            key: "10"
                          }
                        : undefined,
                      (column.prop === 'serviceSentRequiredMaterial')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getYesNoName(scope.row.serviceSentRequiredMaterial)), 1)
                            ]),
                            key: "11"
                          }
                        : undefined,
                      (column.prop === 'isDealt')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.isDealt === 1 ? '已成交' : scope.row.isDealt === 0 ? '未成交' : scope.row.isDealt === 3 ? '未知' : '-'), 1)
                            ]),
                            key: "12"
                          }
                        : undefined,
                      (column.prop === 'contactType')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.contactType == 1 ? '1天内联系' : scope.row.contactType == 2 ? '3天内联系':''), 1)
                            ]),
                            key: "13"
                          }
                        : undefined,
                      (column.prop === 'contactDeadline')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(currentRow.value.date == _unref(dayjs)().format('YYYY-MM-DD') ? '请及时联系' : scope.row.contactDeadline), 1)
                            ]),
                            key: "14"
                          }
                        : undefined,
                      (column.prop === 'customerRequestTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.customerRequestTime)), 1)
                            ]),
                            key: "15"
                          }
                        : undefined,
                      (column.prop === 'customerAddTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.customerAddTime)), 1)
                            ]),
                            key: "16"
                          }
                        : undefined,
                      (column.prop === 'serviceFirstReplyTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.serviceFirstReplyTime)), 1)
                            ]),
                            key: "17"
                          }
                        : undefined,
                      (column.prop === 'materialSendTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.materialSendTime)), 1)
                            ]),
                            key: "18"
                          }
                        : undefined,
                      (column.prop === 'fundAmountInquiryTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.fundAmountInquiryTime)), 1)
                            ]),
                            key: "19"
                          }
                        : undefined,
                      (column.prop === 'courseIntroAndLinkTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.courseIntroAndLinkTime)), 1)
                            ]),
                            key: "20"
                          }
                        : undefined,
                      (column.prop === 'courseForeshadowingTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatDateTime(scope.row.courseForeshadowingTime)), 1)
                            ]),
                            key: "21"
                          }
                        : undefined,
                      (['custName', 'custNickName', 'consumerNickName', 'nickname', 'customerNickname'].includes(column.prop))
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(formatCustomerNickname(scope.row[column.prop])), 1)
                            ]),
                            key: "22"
                          }
                        : undefined,
                      (column.prop === 'responseWithinRequiredTime')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.responseWithinRequiredTime), 1)
                            ]),
                            key: "23"
                          }
                        : undefined,
                      (column.prop === 'hasFundAmountInquiry')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getYesNoName(scope.row.hasFundAmountInquiry)), 1)
                            ]),
                            key: "24"
                          }
                        : undefined,
                      (column.prop === 'hasCourseIntroAndLink')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getYesNoName(scope.row.hasCourseIntroAndLink)), 1)
                            ]),
                            key: "25"
                          }
                        : undefined,
                      (column.prop === 'hasCourseForeshadowing')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getYesNoName(scope.row.hasCourseForeshadowing)), 1)
                            ]),
                            key: "26"
                          }
                        : undefined,
                      (column.prop === 'isViolation')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", {
                                style: _normalizeStyle({ color: scope.row.isViolation === 1 ? '#f56c6c' : '' })
                              }, _toDisplayString(scope.row.isViolation === 1 ? '是' : scope.row.isViolation === 0 ? '否' : '-'), 5)
                            ]),
                            key: "27"
                          }
                        : undefined,
                      (column.prop === 'hasRecentEmployeeMessage')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getYesNoName(scope.row.hasRecentEmployeeMessage) || '-'), 1)
                            ]),
                            key: "28"
                          }
                        : undefined,
                      (column.prop === 'resultStatus')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getResponseSlaStatusName(scope.row.resultStatus)), 1)
                            ]),
                            key: "29"
                          }
                        : undefined,
                      (column.prop === 'postMaterialReplies')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createVNode(_unref(ElTooltip), {
                                effect: "dark",
                                placement: "top",
                                "show-after": 200
                              }, {
                                content: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_27, _toDisplayString(formatMultilineText(scope.row.postMaterialReplies)), 1)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(formatMultilineText(scope.row.postMaterialReplies)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            key: "30"
                          }
                        : undefined,
                      (column.prop === 'signStatus')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('signStatus', scope.row.signStatus)), 1)
                            ]),
                            key: "31"
                          }
                        : undefined,
                      (column.prop === 'status')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('status', scope.row.status)), 1)
                            ]),
                            key: "32"
                          }
                        : undefined,
                      (column.prop === 'channelCode')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(getDictName('channelCode', scope.row.channelCode)), 1)
                            ]),
                            key: "33"
                          }
                        : undefined,
                      (column.prop === 'price')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, "￥" + _toDisplayString(parseFloat((scope.row.price / 100).toFixed(2))), 1)
                            ]),
                            key: "34"
                          }
                        : undefined,
                      (column.prop === 'refundAmount')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, "￥" + _toDisplayString(parseFloat((scope.row.refundAmount / 100).toFixed(2))), 1)
                            ]),
                            key: "35"
                          }
                        : undefined,
                      (column.prop === 'avatar')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.avatar)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    src: scope.row.avatar,
                                    "preview-src-list": [scope.row.avatar],
                                    fit: "cover",
                                    style: {"width":"40px","height":"40px","border-radius":"50%","cursor":"pointer"}
                                  }, {
                                    error: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Picture))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_30, "-"))
                            ]),
                            key: "36"
                          }
                        : undefined,
                      (column.prop === 'consumerHeadImgUrl')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.consumerHeadImgUrl)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    src: scope.row.consumerHeadImgUrl,
                                    "preview-src-list": [scope.row.consumerHeadImgUrl],
                                    fit: "cover",
                                    style: {"width":"40px","height":"40px","border-radius":"50%","cursor":"pointer"}
                                  }, {
                                    error: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_31, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Picture))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
                            ]),
                            key: "37"
                          }
                        : undefined,
                      (column.prop === 'custImage')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.custImage)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    src: scope.row.custImage,
                                    "preview-src-list": [scope.row.custImage],
                                    fit: "cover",
                                    style: {"width":"40px","height":"40px","border-radius":"50%","cursor":"pointer"}
                                  }, {
                                    error: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Picture))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_34, "-"))
                            ]),
                            key: "38"
                          }
                        : undefined,
                      (column.prop === 'customerAvatar')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.customerAvatar)
                                ? (_openBlock(), _createBlock(_component_el_image, {
                                    key: 0,
                                    src: scope.row.customerAvatar,
                                    "preview-src-list": [scope.row.customerAvatar],
                                    fit: "cover",
                                    style: {"width":"40px","height":"40px","border-radius":"50%","cursor":"pointer"}
                                  }, {
                                    error: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_35, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Picture))
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["src", "preview-src-list"]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_36, "-"))
                            ]),
                            key: "39"
                          }
                        : undefined,
                      (column.prop === 'empUserId' && currentTabConfig.value?.key === 'performanceSummary')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.groupName)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(scope.row.empUserId) + "(" + _toDisplayString(scope.row.groupName) + ")", 1))
                                : (scope.row.handoverTime)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(scope.row.empUserId) + "(" + _toDisplayString(formatHandoverTime(scope.row.handoverTime)) + ")", 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(scope.row.empUserId), 1))
                            ]),
                            key: "40"
                          }
                        : undefined,
                      (column.prop === 'empUserId' && currentTabConfig.value?.key !== 'performanceSummary')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.groupName && currentTabConfig.value?.key !== 'yesterdayNoReply')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(scope.row.empUserId) + "(" + _toDisplayString(scope.row.groupName) + ")", 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(scope.row.empUserId), 1))
                            ]),
                            key: "41"
                          }
                        : undefined,
                      (column.prop === 'expectedPerformance' || column.prop === 'actualPerformance' || column.prop === 'performanceDifference')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row[column.prop] || 0), 1)
                            ]),
                            key: "42"
                          }
                        : undefined,
                      (column.prop === 'deptName' && currentTabConfig.value?.key === 'performanceSummary')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              _createElementVNode("span", null, _toDisplayString(scope.row.deptName), 1)
                            ]),
                            key: "43"
                          }
                        : undefined,
                      (column.prop === 'empName' && currentTabConfig.value?.key === 'performanceSummary')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.dataType === 'dept')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "--"))
                                : (scope.row.dataType === 'emp')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(scope.row.empName || '--'), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(scope.row.empName || '--'), 1))
                            ]),
                            key: "44"
                          }
                        : undefined,
                      (column.prop === 'empUserId' && currentTabConfig.value?.key === 'performanceSummary')
                        ? {
                            name: "default",
                            fn: _withCtx((scope) => [
                              (scope.row.dataType === 'dept' || scope.row.dataType === 'emp')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_45, "--"))
                                : (scope.row.groupName)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(scope.row.empUserId) + "(" + _toDisplayString(scope.row.groupName) + ")", 1))
                                  : (scope.row.handoverTime)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(scope.row.empUserId) + "(" + _toDisplayString(formatHandoverTime(scope.row.handoverTime)) + ")", 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_48, _toDisplayString(scope.row.empUserId), 1))
                            ]),
                            key: "45"
                          }
                        : undefined
                    ]), 1032, ["prop", "label", "min-width", "show-overflow-tooltip"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["data", "tree-props"]),
              _createElementVNode("div", _hoisted_49, [
                (currentTabConfig.value?.key !== 'performanceSummary')
                  ? (_openBlock(), _createBlock(_component_el_pagination, {
                      key: 0,
                      "current-page": page.value.pageNo,
                      "page-sizes": [10, 20, 30, 40, 100],
                      "page-size": page.value.pageSize,
                      layout: "total,  prev, pager, next, jumper",
                      total: page.value.total,
                      onSizeChange: handleSizeChange,
                      onCurrentChange: handleCurrentChange
                    }, null, 8, ["current-page", "page-size", "total"]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true),
        (currentTabConfig.value?.key == 'weekCallLessOrTimeLess' && isEmp.value && tableData.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _createElementVNode("div", _hoisted_53, [
                  _createTextVNode(_toDisplayString(tableData.value[0]?.totalCallCount ?? 0), 1),
                  _hoisted_54
                ]),
                _createElementVNode("div", {
                  class: "color-bar",
                  style: _normalizeStyle({width: (String(tableData.value[0]?.totalCallCount)?.length ?  String(tableData.value[0]?.totalCallCount)?.length : 1) * 21 + 'px'})
                }, null, 4)
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _createElementVNode("div", _hoisted_57, [
                  _createTextVNode(_toDisplayString(tableData.value[0]?.totalCallDurationMin ?? 0), 1),
                  _hoisted_58
                ]),
                _createElementVNode("div", {
                  class: "color-bar",
                  style: _normalizeStyle({width: (String(tableData.value[0]?.totalCallDurationMin)?.length ?  String(tableData.value[0]?.totalCallDurationMin)?.length : 1) * 21 + 'px'})
                }, null, 4)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})